import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import  {Stripe} from "@stripe/stripe-js";
import {loadStripe} from '@stripe/stripe-js'; 
import { DOCUMENT } from "@angular/common";
import { getToken } from "firebase/app-check";
declare var Stripe : any;
import { InventoryServiceService } from "../confirmation-screen/inventory-service.service";
import { json } from "express";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "src/app/global/global";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-confirmation-screen",
  templateUrl: "./confirmation-screen.component.html",
  styleUrls: ["./confirmation-screen.component.css"]
})
export class ConfirmationScreenComponent implements OnInit {
  inventoryFormData: any;
  type:any;
  stripe = Stripe
  ("pk_live_51MhDUDFGzVjaUNdakIyzHtFEmARx5iFsCLh51MSsNXMoaYAsTDpzcYwQldD8Igk088CjIcQKEQPK00cHEyutwMJ200RyNsFE4E"); 
  constructor(public router: Router,public activeRouter: ActivatedRoute,private api: AdminService,private toastrService: ToastrService) { 
  }
 
  ngOnInit(): void {
    this.activeRouter.queryParams.subscribe(params => {
      this.type=params.type
      if(this.type == "inventory"){
        this.inventoryFormData=JSON.parse(params.data)
      }
    });
    if(this.type == "inventory"){
      const clientSecret = new URLSearchParams(window.location.search).get(
        'setup_intent_client_secret'
      );
      this.stripe.retrieveSetupIntent(clientSecret).then(({setupIntent}) => {
        switch (setupIntent.status) {
          case 'succeeded': {
            let data={
              ...this.inventoryFormData,
              cardId:setupIntent?.payment_method
            }
            this.api.postData(apiUrl._addPurchasePlanV1, data)
            .subscribe(async (res) => {
              // this.router.navigate(["/account-settings/inventory-history"])
              setTimeout(() => {
                this.router.navigate(["/account-settings/inventory-history"])
              }, 1500);
            })
            break;
          }
          case 'processing': {
            this.toastrService.info("","Processing payment details. We'll update you when processing is complete.")
            break;
          }
          case 'requires_payment_method': {
            this.toastrService.error("",'Failed to process payment details. Please try another payment method.')
            break;
          }
        }
      });
    } else if(this.type =="subscription"){
      // this.router.navigate(["/account-settings/subscription"]);
      setTimeout(() => {
        this.router.navigate(["/account-settings/subscription"]);
      }, 1500);
    }else{ 
      setTimeout(() => {
          this.router.navigate(["/dashboard"]);
        }, 1500);
    }
  }
}

